import React from "react";
import FacebookLink from "./facebook_link";
import TwitterLink from "./twitter_link";

function SocialLinks(props) {
  return (
    <React.Fragment>
      <FacebookLink {...props} />
      <TwitterLink {...props} />
    </React.Fragment>
  );
}

export default SocialLinks;
